var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Settings2 = function Settings2(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.323 3.912c.874-2.55 4.48-2.55 5.354 0a.83.83 0 0 0 1.15.476c2.42-1.185 4.97 1.365 3.784 3.786a.83.83 0 0 0 .477 1.15c2.55.873 2.55 4.48 0 5.353a.83.83 0 0 0-.477 1.15c1.186 2.42-1.364 4.97-3.785 3.784a.83.83 0 0 0-1.15.477c-.873 2.55-4.48 2.55-5.353 0a.83.83 0 0 0-1.15-.477c-2.42 1.186-4.97-1.364-3.785-3.785a.83.83 0 0 0-.476-1.15c-2.55-.873-2.55-4.48 0-5.353a.83.83 0 0 0 .476-1.15c-1.185-2.42 1.365-4.97 3.786-3.785a.83.83 0 0 0 1.15-.476Zm3.462.649c-.256-.748-1.314-.748-1.57 0a2.83 2.83 0 0 1-3.92 1.624c-.71-.348-1.458.4-1.11 1.11a2.83 2.83 0 0 1-1.624 3.92c-.748.256-.748 1.314 0 1.57a2.83 2.83 0 0 1 1.624 3.92c-.348.71.4 1.458 1.11 1.11a2.83 2.83 0 0 1 3.92 1.624c.256.748 1.314.748 1.57 0a2.83 2.83 0 0 1 3.92-1.624c.71.348 1.458-.4 1.11-1.11a2.83 2.83 0 0 1 1.624-3.92c.748-.256.748-1.314 0-1.57a2.83 2.83 0 0 1-1.624-3.92c.348-.71-.4-1.458-1.11-1.11a2.83 2.83 0 0 1-3.92-1.624ZM12 9.974a2.026 2.026 0 1 0 0 4.052 2.026 2.026 0 0 0 0-4.052ZM7.974 12a4.026 4.026 0 1 1 8.052 0 4.026 4.026 0 0 1-8.052 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Settings2;